import React from 'react';
import { Box as MUIBox, Link, styled } from '@mui/material';
const Box = styled(MUIBox)({
    '& a': {
        fontSize: '20px',
        fontWeight: '600',
        color: '#01111f',
        '@media (max-width: 991.98px)': {
            fontSize: '18px',
        },
    },
});

// type ITextColor = 'blue' | 'cyan';

// interface ILogoIndexProps {
//     mithilaColor?: ITextColor;
//     iColor?: ITextColor;
//     tColor?: ITextColor;
// }

const LogoIndex = () => {
    return (
        <>
            <Box justifyItems={'center'} alignItems={'center'}>
                <Link href="/" underline="none">
                    <div style={{ display: 'flex', alignItems: 'center', fontSize: '28px' }}>
                        <img src="/logo/full-logo.png" alt="Mithila IT" height={'42px'} />
                        {/* <span style={{ marginLeft: '10px', color: '#14346C' }}>Mithila</span>{' '}
                        <span style={{ marginLeft: '2px', color: '#13b3b3' }}>I</span>
                        <span style={{ color: '#13b3b3' }}>T</span> */}
                    </div>
                </Link>
            </Box>
        </>
    );
};

export default LogoIndex;
